import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
import { IConfig, IFile } from "./types/_system";
const api = new APIClient();

const path = '';
const baseURL = (window.location.hostname)?.includes('localhost') || (window.location.hostname)?.includes('dev-') ? 'https://dev-console-api.pressai.kr/api/v1' : 'https://console-api.pressai.kr/api/v1';
const systemApi = {
  postUploadFileMulti(dataForm: any): Promise<AxiosResponse<ResponseData<IFile>, any>> {
    const url = `${path}/upload/files`;
    const formData = new FormData();

    if (Array.isArray(dataForm?.files)) {
      dataForm.files.forEach((file: any, index: number) => {
        formData.append(`files`, file);
      });
    } else if (dataForm?.files) {
      formData.append('files', dataForm.files);
    }

    if (dataForm?.action) {
      formData.append('action', dataForm.action);
    }

    return api.post(url, formData, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getConfiguration(params: any = {}): Promise<AxiosResponse<ResponseData<IConfig>, any>> {
    const url = `${path}/systems/configs`;
    return api.get(url, params, {
      baseURL: baseURL,
    })
  },
  putConfiguration(dataForm: any): Promise<AxiosResponse<ResponseData<IConfig>, any>> {
    const url = `${path}/systems/configs`;
    return api.put(url, dataForm, {
      baseURL: baseURL,
    })
  },
}
export default systemApi;
